'use client';

export const comfortFeaturesCheckboxes = [
  {
    label: 'Air Conditioning',
    name: 'airConditioning',
    value: true,
  },
  {
    label: 'Bucket Seats',
    name: 'bucketSeats',
    value: true,
  },
  {
    label: 'Power Brakes',
    name: 'powerBrakes',
    value: true,
  },
  {
    label: 'Power Steering',
    name: 'powerSteering',
    value: true,
  },
  {
    label: 'Power Windows',
    name: 'powerWindows',
    value: true,
  },
  {
    label: 'Power Seats',
    name: 'powerSeats',
    value: true,
  },
  {
    label: 'Tilt Steering Wheel',
    name: 'tiltWheel',
    value: true,
  },
  {
    label: 'Convertible top',
    name: 'hasConvertibleTop',
    value: true,
  },
];

export enum EListingStatus {
  PUBLISHED = 'Published',
  DRAFT = 'Draft',
}
